import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const LOGISTICS_DOMAIN_INTRO = {
  title: "Logistics",
  content: "Agentic AI + Workflow Automation for Logistics — across Freight Forwarding, Courier / Parcel, Customs Brokerage, Cold Chain Logistics, E-Commerce Logistics, and Supply Chain Control Tower. Use cases span enquiry-to-quote automation, delivery exception classification, HS code suggestion support, customs query response packs, cold chain incident summaries, failed delivery customer communication, exception management, and SLA root cause analysis. Practical deployments for 3PLs and supply chain operators in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "Logistics agentic AI use cases — freight forwarding, courier parcel, customs brokerage, cold chain, e-commerce logistics, supply chain control tower. Enquiry-to-quote automation, delivery exception classification, HS code suggestion, cold chain incident summary, exception management agent, SLA root cause analysis. TMS WMS ERP integration.",
};

const slug = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function withMeta(uc) {
  return {
    ...uc,
    groupId: slug(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
  };
}

const LOG_SYSTEMS =
  "TMS, WMS, ERP, CRM, GPS/Telematics, Customs Portal, Carrier Portal, Email, Power BI";

const RAW = [
  {
    id: "enquiry-to-quote-automation",
    subIndustry: "Freight Forwarding",
    department: "Sales / Pricing",
    businessProcess: "Enquiry-to-Quote Automation",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Enquiry-to-Quote Automation",
    title: "AI Enquiry-to-Quote Automation Automation for Freight Forwarding",
    seoKeywords: "enquiry-to-quote automation automation, freight forwarding AI automation, logistics RPA services, agentic AI solution",
    challenge: "Sales / Pricing teams often manage enquiry-to-quote automation for Freight Forwarding through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into freight enquiries are priced through manual email coordination.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to read enquiries, fetch rates and prepare quote drafts. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Freight Forwarding teams can improve enquiry-to-quote automation with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "delivery-exception-classification",
    subIndustry: "Courier / Parcel",
    department: "Last Mile Operations",
    businessProcess: "Delivery Exception Classification",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Delivery Exception Classification",
    title: "AI Delivery Exception Classification Automation for Courier / Parcel",
    seoKeywords: "delivery exception classification automation, courier   parcel AI automation, logistics RPA services, agentic AI solution",
    challenge: "Last Mile Operations teams often manage delivery exception classification for Courier / Parcel through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into delivery exceptions are categorized manually.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to classify failed deliveries and recommend next action. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Courier / Parcel teams can improve delivery exception classification with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "hs-code-suggestion-support",
    subIndustry: "Customs Brokerage",
    department: "Customs Compliance",
    businessProcess: "HS Code Suggestion Support",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "HS Code Suggestion Support",
    title: "AI HS Code Suggestion Support Automation for Customs Brokerage",
    seoKeywords: "hs code suggestion support automation, customs brokerage AI automation, logistics RPA services, agentic AI solution",
    challenge: "Customs Compliance teams often manage hs code suggestion support for Customs Brokerage through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into HS codes are researched manually.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to suggest HS code candidates with human customs review. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Customs Brokerage teams can improve hs code suggestion support with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "12+ months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "customs-query-response-pack",
    subIndustry: "Customs Brokerage",
    department: "Customs Documentation",
    businessProcess: "Customs Query Response Pack",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Customs Query Response Pack",
    title: "AI Customs Query Response Pack Automation for Customs Brokerage",
    seoKeywords: "customs query response pack automation, customs brokerage AI automation, logistics RPA services, agentic AI solution",
    challenge: "Customs Documentation teams often manage customs query response pack for Customs Brokerage through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into customs queries require manual evidence collection.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to collect documents and draft response for broker review. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Customs Brokerage teams can improve customs query response pack with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "cold-chain-incident-summary",
    subIndustry: "Cold Chain Logistics",
    department: "Quality",
    businessProcess: "Cold Chain Incident Summary",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Cold Chain Incident Summary",
    title: "AI Cold Chain Incident Summary Automation for Cold Chain Logistics",
    seoKeywords: "cold chain incident summary automation, cold chain logistics AI automation, logistics RPA services, agentic AI solution",
    challenge: "Quality teams often manage cold chain incident summary for Cold Chain Logistics through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into incident reports are written manually.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to summarize deviation timeline and corrective actions. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Cold Chain Logistics teams can improve cold chain incident summary with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "failed-delivery-customer-communication",
    subIndustry: "E-Commerce Logistics",
    department: "Customer Service",
    businessProcess: "Failed Delivery Customer Communication",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Failed Delivery Customer Communication",
    title: "AI Failed Delivery Customer Communication Automation for E-Commerce Logistics",
    seoKeywords: "failed delivery customer communication automation, e-commerce logistics AI automation, logistics RPA services, agentic AI solution",
    challenge: "Customer Service teams often manage failed delivery customer communication for E-Commerce Logistics through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into failed delivery communication is inconsistent.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to draft customer communication and schedule reattempt workflow. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "E-Commerce Logistics teams can improve failed delivery customer communication with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "exception-management-agent",
    subIndustry: "Supply Chain Control Tower",
    department: "Control Tower",
    businessProcess: "Exception Management Agent",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Exception Management Agent",
    title: "AI Exception Management Agent Automation for Supply Chain Control Tower",
    seoKeywords: "exception management agent automation, supply chain control tower AI automation, logistics RPA services, agentic AI solution",
    challenge: "Control Tower teams often manage exception management agent for Supply Chain Control Tower through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into exceptions are handled manually by coordinators.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to prioritize exceptions and recommend next best action. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Supply Chain Control Tower teams can improve exception management agent with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "sla-root-cause-analysis",
    subIndustry: "Supply Chain Control Tower",
    department: "Control Tower",
    businessProcess: "SLA Root Cause Analysis",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "SLA Root Cause Analysis",
    title: "AI SLA Root Cause Analysis Automation for Supply Chain Control Tower",
    seoKeywords: "sla root cause analysis automation, supply chain control tower AI automation, logistics RPA services, agentic AI solution",
    challenge: "Control Tower teams often manage sla root cause analysis for Supply Chain Control Tower through emails, spreadsheets, portals, and manual checks. This creates delays, inconsistent validation, rework, and limited visibility into SLA failures need manual root cause analysis.",
    solution: "Deploy an Agentic AI + Workflow Automation solution to summarize delay causes and improvement actions. The workflow should include business rules, human review for exceptions, status tracking, and audit evidence.",
    summary: "Supply Chain Control Tower teams can improve sla root cause analysis with agentic AI and workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Workflow Automation",
    buyerPersona: "COO, Logistics Head, Operations Head, Warehouse Head, Fleet Head, Customer Service Head, CIO",
    systems: LOG_SYSTEMS,
    agentsRequired: "Planner Agent, Data Retrieval Agent, Rule Validation Agent, Action Agent, Exception Agent",
    inputData: "Emails, forms, approval matrix, SOPs, transaction records, master data",
    outputActions: "Workflow task, approval request, status update, exception report",
    keyBenefits: "Multi-Step Workflow Automation, Better Exception Handling, Faster Decision Support",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];

export const LOGISTICS_USE_CASES = RAW.map(withMeta);

const GROUP_ORDER = [
  "Freight Forwarding",
  "Courier / Parcel",
  "Customs Brokerage",
  "Cold Chain Logistics",
  "E-Commerce Logistics",
  "Supply Chain Control Tower",
];

export const LOGISTICS_GROUPS = GROUP_ORDER.map((label) => ({
  id: slug(label),
  label,
})).filter((g) => LOGISTICS_USE_CASES.some((uc) => uc.groupId === g.id));

const logisticsSeo = buildDomainSeoBundle({
  domainSlug: "logistics-domain",
  domainIntro: LOGISTICS_DOMAIN_INTRO,
  useCases: LOGISTICS_USE_CASES,
});

export const LOGISTICS_USE_CASES_SEO = logisticsSeo.useCasesSeo;
export const LOGISTICS_DOMAIN_FAQS = logisticsSeo.domainFaqs;
export const LOGISTICS_ITEM_LIST_JSONLD = logisticsSeo.itemListJsonLd;
export const LOGISTICS_FAQ_JSONLD = logisticsSeo.faqJsonLd;
export const LOGISTICS_BREADCRUMB_JSONLD = logisticsSeo.breadcrumbJsonLd;
export const LOGISTICS_WEBPAGE_JSONLD = logisticsSeo.webPageJsonLd;

